import { render, staticRenderFns } from "./hljaccountsReceivableStatistics.vue?vue&type=template&id=81015780&scoped=true"
import script from "./hljaccountsReceivableStatistics.vue?vue&type=script&lang=js"
export * from "./hljaccountsReceivableStatistics.vue?vue&type=script&lang=js"
import style0 from "./hljaccountsReceivableStatistics.vue?vue&type=style&index=0&id=81015780&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81015780",
  null
  
)

export default component.exports